import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const userGroupsReducer = (state = initialState.userProfile.userGroups, action) => {
  switch (action.type) {
    case actionTypes.LOAD_USER_PROFILE_GROUPS_STARTED: {
      return {
        ...state,
        loading: true
      };
    }
    case actionTypes.LOAD_USER_PROFILE_GROUPS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        groups: action.payload
      };
    }

    default:
      return state;
  }
};

export default userGroupsReducer;
